<aside class="main-sidebar sidebar-dark-primary elevation-4"
  [ngStyle]="{'background-color':(!finance) ? '#AA7719' : '#2d6dd7' }" style="font-family: 'Sarabun', sans-serif;">
  <!-- Brand Logo -->
  <a href="" (click)="false" class="brand-link">
    <img src="assets/images/bsflogo.png" alt="BRD Logo" class="brand-image img-circle elevation-3"
      style="opacity: .8; background-color: white;">
    <span class="brand-text font-weight-light headText2">ระบบไร่ออนไลน์ </span>
  </a>
  <mat-slide-toggle *ngIf="enabled[0]" [(ngModel)]="enabled[1]">enabled</mat-slide-toggle>
  <!-- Sidebar -->
  <div class="sidebar">
    <!-- SidebarSearch Form -->

    <!-- Sidebar Menu -->
    <nav class="mt-2" style=" color: rgb(255, 140, 140);">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>Dashboard <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/dashboard-brd']" routerLinkActive="active" class="nav-link">
                - <i class="far fa-circle nav-icon"></i>
                <p>Dashboard BRD</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/dashboardkpi']" routerLinkActive="active" class="nav-link">
                - <i class="far fa-circle nav-icon"></i>
                <p>Dashboard เขต</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/dashboard_cutF']" routerLinkActive="active" class="nav-link">
                - <i class="nav-icon fas fa-chart-pie"></i>
                <p>Dashboard-แปลงตัดเสร็จ</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/dashboard_growedY']" routerLinkActive="active" class="nav-link">
                - <i class="nav-icon fas fa-chart-pie"></i>
                <p>Dashboard-แปลงปลูกเสร็จ</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/follow-work']" routerLinkActive="active" class="nav-link">
                - <i class="nav-icon fas fa-chart-bar"></i>
                <p>ติดตามงาน</p>
              </a>
            </li>
          </ul>
        </li>

        <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
          <a routerLinkActive="active" class="nav-link" [routerLink]="['/supporter']">
            <i class="nav-icon fas fa-home"></i>
            <p>
              หน้าแรก
            </p>
          </a>
        </li>

        <li [hidden]="!director" class="nav-item" routerLinkActive="menu-open">
          <a routerLinkActive="active" class="nav-link" [routerLink]="['/emp']">
            <i class="nav-icon fas fa-user-tie"></i>
            <p>
              ระบบบริหารงานพนักงาน
            </p>
          </a>
        </li>

        <li [hidden]="finance" class="nav-item" routerLinkActive="menu-open">
          <a routerLinkActive="active" class="nav-link" [routerLink]="['/finance']">
            <i class="nav-icon fas fa-home"></i>
            <p>
              DashBoard
            </p>
          </a>
        </li>

        <!-- ผจก หัวหน้าส่วน -->
        <li [hidden]="orther" class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-copy"></i>
            <p>
              รายการตรวจสอบ | อนุมัติ
              <i class="right fas fa-angle-left"></i>
              <i *ngIf="cntAuditAlert !=0" class="far fa-bell icon-animated-vertical bg-danger"></i>
            </p>

          </a>
          <ul class="nav nav-treeview">
            <!--
                        <li [hidden]="(!pr || manager)" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showFormEditPlot_manager();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p>ขอแก้ไขข้อมูลแปลง</p>
                            </a>
                        </li>

                         <li [hidden]="(!pr || manager)" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showeditplant_manager();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p>คำขอแก้ไขข้อมูลแปลงอ้อย</p>
                            </a>
                        </li>                        -->
            <!-- <li [hidden]="manager" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showfertilizer3();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p> อนุมัติปุ๋ย 3</p>
                            </a>
                        </li> -->
            <li [hidden]="pathhead" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/News_Edit']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-archive nav-icon"></i>
                <p> แก้ไขหน้าข่าว</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/actionplant']" routerLinkActive="active" class="nav-link">
                - <i class="far fa-edit nav-icon"></i>
                <p> บันทึกกิจกรรมแปลง</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/auditList']" routerLinkActive=" active" class="nav-link">
                - <i class="fas fa-user-check"> รายการจากออดิต </i>
                <i *ngIf="cntAuditAlert !=0" class="far fa-bell icon-animated-vertical text-warning ml-2"></i>
              </a>
            </li>
            <li [hidden]="pathhead" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/borrowQueue']" routerLinkActive="active" class="nav-link">
                - <i class="nav-icon fas fa-copy"></i>
                <p> ขอยืมคิวข้ามกลุ่ม </p>
              </a>
            </li>

            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a [routerLink]="['/move-on-q']" routerLinkActive="active" class="nav-link">
                                -<i class="far fa-id-badge nav-icon"></i>
                                <p>แก้ไขการโอนย้ายคิว</p>
                            </a>
                        </li>
                         <li [hidden]="headmanager" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showeditplant_manager();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p>คำขอแก้ไขข้อมูลแปลงอ้อย</p>
                            </a>
                        </li>  -->
            <!-- <li [hidden]="pathhead" class="nav-item" routerLinkActive="menu-open" >
                            <a [ngClass]="{'nav-link': true,'active': false}" (click)="showBarcodelist();">
                                <i class="nav-icon fas fa-copy"></i>
                                <p>
                                    อนุมัติบาร์โค้ดคิว
                                </p>
                            </a>
                        </li>
                        
                        <li [hidden]="headmanager" class="nav-item" routerLinkActive="menu-open" >
                            <a [ngClass]="{'nav-link': true,'active': false}" (click)="showBorrowqueue();">
                                <i class="nav-icon fas fa-copy"></i>
                                <p>
                                    อนุมัติคิวข้ามกลุ่ม (กำลังทดสอบ)
                                </p>
                            </a>
                        </li> -->
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showkpisupportter();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p>สรุป KPI นักส่งเสริม</p>
                            </a>
                        </li> -->
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showkpiheadzone();">
                                - - <i class="far fa-circle nav-icon"></i>
                                <p>สรุป KPI หัวหน้าส่วนส่งเสริม (ยังไม่เปิดใช้งาน)</p>
                            </a>
                        </li> 
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showkpimanager();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p>สรุป KPI ผู้จัดการเขต (ยังไม่เปิดใช้งาน)</p>
                            </a>
                        </li> -->

          </ul>
        </li>

        <hr>
        <!-- KPI -->
        <li [hidden]="!finance" class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-copy"></i>
            <p>KPI Online
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showkpi();">
                                - <i class="far fa-list-alt nav-icon"></i>
                                <p> KPI ประจำงวดของฉัน</p>
                            </a>
                        </li> 
                        -->
            <!-- 
                        <li [hidden]="!finance || !pr" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showkpi(1);">
                                - <i class="far fa-edit nav-icon"></i>
                                <p>บันทึกเป้าหมาย KPI</p>
                            </a>
                        </li>
                        </li>-->
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/ListKpi']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-book-reader nav-icon"></i>
                <p> งวด KPI นสส</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/Kpi-Zone']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-book-reader nav-icon"></i>
                <p> งวด KPI เขต</p>
              </a>
            </li>

          </ul>
        </li>

        <!-- ข้อมูลแปลงอ้อย -->
        <li class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-map-marked-alt"></i>
            <p>ข้อมูลแปลงอ้อย <i class="right fas fa-angle-left"></i> </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/findlanddata']">
                - <i class="fas fa-search nav-icon"></i>
                <p> สืบค้นข้อมูลแปลง</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/map']">
                - <i class="fas fa-map-marked-alt nav-icon"></i>
                <p> แผนที่แปลงอ้อย</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/brdproject']">
                - <i class="fas fa-cog fa-spin nav-icon"></i>
                <p> โครงการสนับสนุน</p>
              </a>
            </li>
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/project_Mem']">
                - <i class="fa fa-crosshairs fa-spin nav-icon"></i>
                <p> สมัครเข้าโครงการ </p>
              </a>
            </li>
            <!-- <li [hidden]="(!pr || manager) || !finance" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showeditplantinfor()">
                                -- <i class="fas fa-edit nav-icon"></i>
                                <p> แก้ไขข้อมูลแปลง </p>
                            </a>
                        </li>
                        <li [hidden]="(!pr || manager) || !finance" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showeditcaneinplant()">
                                -- <i class="fas fa-edit nav-icon"></i>
                                <p> แก้ไขอ้อยเข้าหีบผิดแปลง </p>
                            </a>
                        </li> -->
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/groupcut']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-info-circle nav-icon"></i>
                <p> บันทึกขัอมูล แปลงอ้อย </p>
              </a>
            </li>
            <li [hidden]="!pr || !finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/addcutcanetype']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-edit nav-icon"></i>
                <p> บันทึกวันตัด/ตัดเสร็จ</p>
              </a>
            </li>
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/new-inform']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-search nav-icon"></i>
                <p>บันทึกพื้นที่ จดแจ้ง</p>
              </a>
            </li>
            <li [hidden]="!pr || manager || !finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/bugandgerm']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-edit nav-icon"></i>
                <p> บันทึกโรคและแมลง</p>
              </a>
            </li>

            <li [hidden]="!pr || manager || !finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/DismanAreaLv']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-align-center nav-icon"></i>
                <p> การตัดพื้นที่รื้อตอและระดับพื้นที่</p>
              </a>
            </li>
            <!--
                        <li [hidden]="!finance"
                            [ngClass]="{'nav-item': true,'menu-is-opening menu-open':  activetab == 4}">
                        
                            <a [ngClass]="{'nav-link': true,'active': activetab == 4}" (click)="clicked(29);">
                                - <i class="far fa-clipboard nav-icon"></i>
                                <p> กิจกรรมแปลง 64/65</p>
                                <i class="right fas fa-angle-left"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <li class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showaction6465()">
                                        - - <i class="fas fa-file-contract nav-icon"></i>
                                        <p>แบบติดตามกิจกรรมแปลงอ้อย</p>
                                    </a>
                                </li>
                                <li class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showgrade6465()">
                                        - - <i class="fas fa-columns nav-icon"></i>
                                        <p>เกรดแปลง 64/65</p>
                                    </a>
                                </li>
                                 
                                <li class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showactioncomment();">
                                        - - <i class="fas fa-clipboard-list"></i>
                                        <p> แบบฟอร์มประเมินอ้อย <br>ตามหลักวิชาการ</p>
                                    </a>
                                </li>

                            </ul>
                        </li>

                        <li [hidden]="!finance"
                            [ngClass]="{'nav-item': true,'menu-is-opening menu-open': activetab == 5}"
                            (click)="clicked(30);">
                            <a [ngClass]="{'nav-link': true,'active': activetab == 5}">
                                - <i class="fas fa-clipboard nav-icon"></i>
                                <p> กิจกรรมแปลง 65/66</p>
                                <i class="right fas fa-angle-left"></i>
                            </a>
                            <ul class="nav nav-treeview">
                                <li [hidden]="!pr" class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showmorearea6566()">
                                        -- <i class="fas fa-globe-asia nav-icon"></i>
                                        <p> พื้นที่ขยาย 65/66</p>
                                    </a>
                                </li>
                                
                                <li [hidden]="!pr || manager" class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showdocmeetfarmer()">
                                        -- <i class="fas fa-edit nav-icon"></i>
                                        <p> บันทึกใบตรวจเยี่ยม</p>
                                    </a>
                                </li>

                            </ul>
                        </li>-->
          </ul>
        </li>


        <!-- ข้อมูลสนับสนุน -->
        <li class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-th"></i>
            <p>
              ข้อมูลสนับสนุน
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/findfarmerdata']" routerLinkActive="active" class="nav-link" target="_blank">
                -<i class="fas fa-search nav-icon"></i>
                <p> สืบค้นข้อมูลชาวไร่</p>
              </a>
            </li>
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FarmerAssess']" routerLinkActive="active" class="nav-link">
                -<i class="fas fa-book-reader nav-icon"></i>
                <p> การประเมินชาวไร่(ความรู้) </p>
              </a>
            </li>

            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/bangkokbank']" routerLinkActive="active" class="nav-link">
                -<i class="fas fa-money-check nav-icon"></i>
                <p>บัญชีธนาคารกรุงเทพ</p>
              </a>
            </li>
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/repairgroup']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-users nav-icon"></i>
                <p> กลุ่มตัด | กลุ่มบำรุง </p>
              </a>
            </li>

            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/raindrop']" routerLinkActive="active" class="nav-link">
                - <i class="fa fa-tint nav-icon"></i>
                <p> ปริมาณน้ำฝน </p>
              </a>
            </li>
          </ul>
        </li>


        <!-- PR -->
        <li class="nav-item" routerLinkActive="menu-open" [hidden]="pr">
          <a [routerLink]="['/farmer_dev_sys']" routerLinkActive="active" class="nav-link">
            <i class="nav-icon fas fa-clipboard-check"></i>
            - - <p>งานประเมินและ<br>ติดตามการฝึกอบรม</p>
          </a>

        </li>

        <!-- สินเชื่อ -->
        <li [hidden]="!pr || !headerfinance || !finance" class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-copy"></i>
            <p>สินเชื่อออนไลน์<i class="fas fa-angle-left right"></i></p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/historyaskformoney']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-seedling nav-icon"></i>
                <p>ประวัติการเบิกเกี๊ยว / ปัจจัย</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FinanceList']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-money-bill nav-icon"></i>
                <p>ค้นข้อมูลการขอเกี๊ยว</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FinanceOfdata']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-money-bill-wave nav-icon"></i>
                <p>สรุปข้อมูลรายการขอเกี้ยว</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FileFinance']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-file-download nav-icon"></i>
                <p> ไฟล์สินเชื่อ</p>
              </a>
            </li>
            <!--<li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/Upfile']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-file-pdf nav-icon"></i>
                <p> อัพโหลดไฟล์ </p>
              </a>
            </li>-->

            <!--<li class="nav-item" routerLinkActive="menu-open">
              <a [ngClass]="{'nav-link': true}">
                - <i class="far fa-address-book nav-icon"></i>
                <p>ปี 66/67 <i class="fas fa-angle-left right"></i></p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/credit/6667']">
                    - -<i class="far fa-id-card nav-icon"></i>
                    <p>สัญญาค้ำประกัน </p>
                  </a>
                </li>
                <li [hidden]="manager" class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askformoney6667']">
                    - -<i class="far fa-id-card nav-icon"></i>
                    <p>ขอเกี๊ยว </p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askfactor6667']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> เบิกปัจจัย</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a [routerLink]="['/getfert3']" routerLinkActive="active" class="nav-link">
                    - - <i class="far fa-list-alt nav-icon"></i>
                    <p> ขอปุ๋ยรอบ 3</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/printfertilizer/6667']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> พิมพ์ใบจ่ายปุ๋ย</p>
                  </a>
                </li>

                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/docforaskformoney2/6667']">
                    - -<i class="far fa-list-alt nav-icon"></i>
                    <p> พิมพ์ใบปะหน้าเกี๊ยว</p>
                  </a>
                </li>                
              </ul>
            </li>-->
            <!--
            <li class="nav-item has-treeview" routerLinkActive="menu-open">
              <a class="nav-link">
                - <i class="far fa-address-book nav-icon"></i>
                <p>สินเชื่อ ปี67/68 <i class="fas fa-angle-left right"></i></p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/credit/6768']">
                    - -<i class="far fa-id-card nav-icon"></i>
                    <p>สัญญาค้ำประกัน </p>
                  </a>
                </li>
                <li [hidden]="manager" class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askformoney/6768']">
                    - - <i class="far fa-id-card nav-icon"></i>
                    <p> ขอเกี๊ยว</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askfactor/6768']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> เบิกปัจจัย</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/printfertilizer/6768']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> พิมพ์ใบจ่ายปุ๋ย</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/docforaskformoney2/6768']">
                    - - <i class="far fa-list-alt nav-icon"></i>
                    <p> พิมพ์ใบปะหน้าเกี๊ยว</p>
                  </a>
                </li>
              </ul>
            </li>-->
            <li class="nav-item has-treeview" routerLinkActive="menu-open">
              <a class="nav-link">
                - <i class="far fa-address-book nav-icon"></i>
                <p>สินเชื่อ ปี68/69 <i class="fas fa-angle-left right"></i></p>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/credit/6869']">
                    - -<i class="far fa-id-card nav-icon"></i>
                    <p>สัญญาค้ำประกัน </p>
                  </a>
                </li>

                <li [hidden]="manager" class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askformoney/6869']">
                    - - <i class="far fa-id-card nav-icon"></i>
                    <p> ขอเกี๊ยว</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/askfactor/6869']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> เบิกปัจจัย</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/printfertilizer/6869']">
                    - - <i class="far fa-circle nav-icon"></i>
                    <p> พิมพ์ใบจ่ายปุ๋ย</p>
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="menu-open">
                  <a routerLinkActive="active" class="nav-link" [routerLink]="['/docforaskformoney2/6869']">
                    - - <i class="far fa-list-alt nav-icon"></i>
                    <p> พิมพ์ใบปะหน้าเกี๊ยว</p>
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/print_farmers']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-address-book nav-icon"></i>
                <p> การขอเบิกรายชาวไร่</p>
              </a>
            </li>
          </ul>
        </li>



        <!-- ฤดูหีบ -->
        <li [hidden]="!finance" class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-briefcase"></i>
            <p>
              ฤดูหีบอ้อย
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/map_groupcode']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-map-marked-alt nav-icon"></i>
                <p> แผนที่กลุ่มตัด</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/Dps-Edit']" target="_blank" routerLinkActive="active" class="nav-link">
                <i class="fab fa-audible nav-icon"></i>
                <p> ระบบฝากหักค่าอ้อย</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/SumDataCut']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-check-circle nav-icon"></i>
                <p> ปริมาณการอ้อยคงเหลือ </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a href="/data_truck.html" routerLinkActive="active" target="_blank" routerLinkActive="active"
                class="nav-link">
                <i class="fa fa-credit-card nav-icon"></i>
                <p>เช็คข้อมูลบัตรเติมน้ำมัน</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/season6465']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p> ข้อมูลรถบรรทุก/รถคีบ </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/oilpay']" routerLinkActive="active" class="nav-link">
                <i class="	fas fa-gas-pump nav-icon"></i>
                <p> เบิกน้ำมัน </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/CaneYard']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-bullseye nav-icon"></i>
                <p> ขอบาร์โค้ดคิว(ส่งลาน) </p>
              </a>
            </li>
            <!--<li [hidden]="supporter" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showaskbarcode();">
                                <i class="fas fa-barcode nav-icon"></i>
                                <p> ขอเพิ่มบาร์โคดแปลงอ้อย </p>
                            </a>
                        </li>-->

            <li [hidden]="supporter" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/acceptbarcode']" routerLinkActive="active" class="nav-link">
                <i class="nav-icon fas fa-copy"></i>
                <p>
                  รายการขอเพิ่มบัตรคิว
                </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/editplantcanein']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-edit nav-icon"></i>
                <p> แก้ไขแปลงเข้าหีบ </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/InforQcard']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p> ดูข้อมูลใบคิว </p>
              </a>
            </li>
            <!--
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showSumDataCut()">
                                <i class="far fa-bell nav-icon"></i>
                                <p> ประมาณการอ้อยคงเหลือ </p>
                            </a>
                        </li>-->
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/QueueAndArear']" routerLinkActive="active" target="_blank" routerLinkActive="active"
                class="nav-link">
                <i class="fas fa-list-ol nav-icon"></i>
                <p>คิวและลานอ้อย</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/SugarCaneperhour']" routerLinkActive="active" target="_blank"
                routerLinkActive="active" class="nav-link">
                <i class="fas fa-stopwatch nav-icon"></i>
                <p>ยอดอ้อยรายชั่วโมง</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/CaneinPerday']" routerLinkActive="active" target="_blank" routerLinkActive="active"
                class="nav-link">
                <i class="fas fa-calendar-day nav-icon"></i>
                <p>ยอดอ้อยประจำวัน</p>
              </a>
            </li>

            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/caneinorderbyzone']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p> ยอดอ้อยรายโซน </p>
              </a>
            </li>

            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/carcut-report']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-truck-moving nav-icon"></i>
                <p> รายงานสถานะรถตัดอ้อย </p>
              </a>
            </li>

            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/caneinbycutcar']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p> อ้อยเข้าหีบโดยรถตัด </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/canpergroup']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p> อ้อยเข้าหีบโดยกลุ่มตัด </p>
              </a>
            </li>

            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/findcaneinstore']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-search nav-icon"></i>
                <p> สืบค้นข้อมูลการส่งอ้อย </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/QueuebyZone']" routerLinkActive="active" class="nav-link">
                <i class="fas fa-list-alt nav-icon"></i>
                <p>ตรวจสอบการใช้คิวโซน </p>
              </a>
            </li>
            <!-- <li class="nav-item" routerLinkActive="menu-open" >
                            <a  routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>ปี 64/65 <i class="right fas fa-angle-left"></i></p>
                            </a>
                            <ul class="nav nav-treeview">
                                
                               
                            </ul>
                        </li> -->

            <!-- <li class="nav-item" routerLinkActive="menu-open" >
                            <a  routerLinkActive="active" class="nav-link">
                                <i class="far fa-list-alt nav-icon"></i>
                                <p>รายงาน <i class="right fas fa-angle-left"></i></p>
                            </a>
                            <ul class="nav nav-treeview">
                               
                                <li   class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showcutrunning();">
                                        - <i class="fas fa-list-alt nav-icon"></i>
                                        <p> ้อยเข้าหีบกลุ่มตัด   </p>
                                    </a>
                                </li>

                                <li   class="nav-item" routerLinkActive="menu-open">
                                    <a routerLinkActive="active" class="nav-link" (click)="showaskbarcode();">
                                        - <i class="fas fa-barcode nav-icon"></i>
                                        <p> ขอเพิ่มบาร์โคดแปลงอ้อย  </p>
                                    </a>
                                </li>
                            </ul>
                        </li> -->
          </ul>
        </li>

        <!-- <li [ngClass]="{'nav-item': true,'menu-is-opening menu-open': onlinereport}" (click)="clicked(6);">
                    <a href="#supporter" [ngClass]="{'nav-link': true,'active': onlinereport}">
                        <i class="nav-icon fas fa-tree"></i>
                        <p>
                            รายงานออนไลน์ (ยังไม่เปิดใช้งาน)
                            <i class="fas fa-angle-left right"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li [ngClass]="{'nav-item': true,'menu-is-opening menu-open': false}">
                            <a href="UI/general.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>KPI Online</p>
                            </a>
                            <ul class="nav nav-treeview">
                                <li class="nav-item" routerLinkActive="menu-open">
                                    <a href="" routerLinkActive="active" class="nav-link">
                                        <i class="far fa-circle nav-icon"></i>
                                        <p>KPI นักส่งเสริม</p>
                                    </a>
                                </li>
                                <li class="nav-item" routerLinkActive="menu-open">
                                    <a href="" routerLinkActive="active" class="nav-link">
                                        <i class="far fa-circle nav-icon"></i>
                                        <p> KPI เขต</p>
                                    </a>
                                </li>
                            </ul>
                        </li>                        
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/buttons.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Buttons</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/sliders.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Sliders</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/modals.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Modals &amp; Alerts</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/navbar.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Navbar &amp; Tabs</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/timeline.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Timeline</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="UI/ribbons.html" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Ribbons</p>
                            </a>
                        </li>
                    </ul>
                </li>
                <li [ngClass]="{'nav-item': true,'menu-is-opening menu-open': formreport}" (click)="clicked(7);">
                    <a href="#supporter" [ngClass]="{'nav-link': true,'active': formreport}">
                        <i class="nav-icon fas fa-edit"></i>
                        <p>
                            แบบฟอร์ม (ยังไม่เปิดใช้งาน)
                            <i class="fas fa-angle-left right"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>General Elements</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Advanced Elements</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Editors</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Validation</p>
                            </a>
                        </li>
                    </ul>
                </li>
                <li [ngClass]="{'nav-item': true,'menu-is-opening menu-open': tabledata}" (click)="clicked(8);">
                    <a href="#supporter" [ngClass]="{'nav-link': true,'active': tabledata}">
                        <i class="nav-icon fas fa-table"></i>
                        <p>
                            ตารางแสดงข้อมูล (ยังไม่เปิดใช้งาน)
                            <i class="fas fa-angle-left right"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>Simple Tables</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>DataTables</p>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="menu-open">
                            <a href="#supporter" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p>jsGrid</p>
                            </a>
                        </li>
                    </ul>
                </li> -->
        <!-- <hr> -->

        <!-- สืนเชื่อ -->
        <li [hidden]="finance" class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-th"></i>
            <p>
              รายการขอเกี๊ยว
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                        <a routerLinkActive="active" class="nav-link" (click)="false">
                            -<i class="fas fa-list-alt nav-icon"></i>
                            <p> ปี 63/64 (พ.สินเชื่อ)</p>
                        </a>
                    </li>
                 
                    <li class="nav-item" routerLinkActive="menu-open">
                        <a routerLinkActive="active" class="nav-link" (click)="false">
                            -<i class="fas fa-list-alt nav-icon"></i>
                            <p> ปี 64/65 (พ.สินเชื่อ)</p>
                        </a>
                    </li> -->
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/OkayGetFert3']" routerLinkActive="active" class="nav-link">
                - <i class="fa fa-book nav-icon"></i>
                <p> อนุมัติปุ๋ยรอบ 3</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FileFinance']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-file-download nav-icon"></i>
                <p> ไฟล์สินเชื่อ</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/Upfile']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-file-pdf nav-icon"></i>
                <p> อัพโหลดไฟล์ </p>
              </a>
            </li>
            <!--
            <li [hidden]="!headerfinance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/listaskformoney66']">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p> ปี 66/67 (พ.สินเชื่อ) </p>
              </a>
            </li>
            <li [hidden]="!headerfinance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/listaskformoney/6768']">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p> ปี 67/68 (พ.สินเชื่อ) </p>
              </a>
            </li>-->
            <li [hidden]="!headerfinance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/listaskformoney/6869']">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p> ปี 68/69 (พ.สินเชื่อ) </p>
              </a>
            </li>
            <!--<li [hidden]="headerfinance" class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showlistforHeaderFinance('6566');">
                                - <i class="fas fa-list-alt nav-icon"></i>
                                <p> ปี 65/66 (ผจก.สินเชื่อ) </p>
                            </a>
                        </li>-->

            <li [hidden]="headerfinance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/listaskHeader']">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p> รายการขอเกี๊ยว (ผจก.สินเชื่อ) </p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/listacceptbyHEADER']" routerLinkActive="active" class="nav-link">
                - <i class="far fa-check-circle nav-icon"></i>
                <p> รายการที่อนุมัติแล้ว</p>
              </a>
            </li>
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/historyaskformoney']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-seedling nav-icon"></i>
                <p>ประวัติการเบิกเกี๊ยว / ปัจจัย</p>
              </a>
            </li>
          </ul>
        </li>

        <!-- รายงาน -->
        <li class="nav-item has-treeview" routerLinkActive="menu-open">
          <a class="nav-link">
            <i class="nav-icon fas fa-th"></i>
            <p>
              รายงาน
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/FarmerReport']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p> สรุปภาพรวมชาวไร่ </p>
              </a>
            </li>
            <!--<li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
                            <a [ngClass]="{'nav-link': true,'active': false}" [routerLink]="['/doccheckfarmer']"
                                routerLinkActive="active" target="_blank">
                                - <i class="fas fa-list-alt nav-icon"></i>
                                <p>
                                    ใบตรวจเยี่ยม 65/66
                                </p>
                            </a>
                        </li>-->
            <li [hidden]="!finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/viewsupportter']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-list-alt nav-icon"></i>
                <p>
                  สรุปผลงาน
                </p>
              </a>
            </li>
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a routerLinkActive="active" class="nav-link" (click)="showdocforgroupcut6566();">
                                 - - <i class="far fa-circle nav-icon"></i>
                                <p>ฟอร์มจัดกลุ่มตัด</p>
                            </a>
                        </li> -->
            <li [hidden]="!pr || !finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/reportplant/H']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-clipboard nav-icon"></i>
                <p> รายงานอ้อยในกลุ่มตัด</p>
              </a>
            </li>
            <li [hidden]="!pr || !finance" class="nav-item" routerLinkActive="menu-open">
              <a [routerLink]="['/reportplant/M']" routerLinkActive="active" class="nav-link">
                - <i class="fas fa-clipboard nav-icon"></i>
                <p> รายงานอ้อยในกลุ่มบำรุง</p>
              </a>
            </li>
            <li [hidden]="supporter|| !finance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/print_cutF']">
                - <i class="fas fa-box-open nav-icon"></i>
                <p> รายงานแปลงตัดเสร็จ </p>
              </a>
            </li>
            <!--
            <li [hidden]="supporter|| !finance" class="nav-item" routerLinkActive="menu-open">
              <a routerLinkActive="active" class="nav-link" [routerLink]="['/brd-diaryCPC']" target="_blank">
                - <i class="fas fa-chart-bar fa-rotate-90"></i>
                <p> ภาพรวม 67/68 </p>
              </a>
            </li>-->
            <!-- <li class="nav-item" routerLinkActive="menu-open">
                            <a href="" routerLinkActive="active" class="nav-link">
                                <i class="far fa-circle nav-icon"></i>
                                <p> ปริมาณน้ำฝน</p>
                            </a>
                        </li> -->
            <!-- <li class="nav-item" routerLinkActive="menu-open" (click)="shownewplantcane();">
                            <a  routerLinkActive="active" class="nav-link">
                                <i class="fas fa-seedling nav-icon"></i>
                                <p> แจ้งโครงการปลูกอ้อย</p>
                            </a>
                        </li>  -->

          </ul>
        </li>

        <li class="nav-item" routerLinkActive="menu-open">
          <a [routerLink]="['/FileExcel']" routerLinkActive="active" class="nav-link">
            <i class="far fa-file-excel nav-icon"></i>
            <p> Download Excel </p>
          </a>
        </li>
      </ul>
    </nav>

    <!-- /.sidebar-menu -->
  </div>


  <!-- /.sidebar -->
</aside>